import { Outlet, useNavigate } from "react-router-dom";
import "./signup-layout.scss";
import { IMenuNavItem } from "../../common/inerfaces/component-interfaces";
import SignupStageHeader from "../../signup/components/signup-stage-header/signup-stage-header";
import { SignupProvider } from "../../signup/providers/signupProvider";

const SignupLayout: React.FC = () => {
  const navigate = useNavigate();
  const menuItemSelectionChangeHandler = (menuItem: IMenuNavItem) => {
    navigate(menuItem.path);
  };
  return (
    <SignupProvider>
      <main className="signup-layout-main">
        <SignupStageHeader />
        <div className="signup-layout-body">
          <Outlet />
        </div>
      </main>
    </SignupProvider>
  );
};

export default SignupLayout;
